import { EMPTY_SECTION_SENTENCES } from "../constants/messages";

/** True when the whole section is only the service's "nothing found" sentence. */
export const isEmptySectionContent = (content: unknown): boolean =>
  typeof content === "string" &&
  EMPTY_SECTION_SENTENCES.includes(content.replace(/[*#]/g, "").trim());
